(ns quuppa.common.malli.transform
  (:require [malli.core :as m]
            [malli.transform :as mt]))

(def api-transformer (mt/transformer
                       (mt/json-transformer)
                       (mt/string-transformer)
                       (mt/default-value-transformer {::mt/add-optional-keys true})))

(def string-transformer (mt/transformer
                          (mt/string-transformer)
                          (mt/default-value-transformer {::mt/add-optional-keys true})))

(def strip-extra-keys (mt/strip-extra-keys-transformer))

(def ui-defaults-transformer (mt/transformer
                               ;; EDNs to strings
                               (mt/string-transformer)
                               ;; default empty strings, possible to set :ui/default in schema
                               (mt/default-value-transformer
                                 {:key :ui/default
                                  :defaults {:map (constantly {})
                                             :enum (comp first m/children)
                                             :string (constantly "")}})))
